import Gallery from "./Gallery.jsx";
export default Gallery